/**
 * List of keys in MutableInspectionAreaFields for use in API calls where only mutable fields should be sent
 */
export const MutableInspectionAreaFieldKeys = [
    'inspection_area_name',
    'camera_profile',
    'order',
    'display_config',
    'span_id',
];
/**
 * List of keys in InspectionAreaSheetSeedFields for use in the create API call
 */
export const InspectionAreaSheetSeedFieldKeys = [
    'creator_name',
    'create_time_user_specified',
    'observer_name',
    'observe_time_user_specified',
    'construction_properties',
];
